// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"np-z","slideIn":"op-z"};